/* eslint-disable react/no-deprecated */
import React from "react";
import { matchRoutes, renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { checkPermissionsOfRoute } from "../../configs/Roles";
import { history } from "../../store";
import PageNotfound from "./page-not-found";
import { getSubRoutes, isValidRoute } from "./common";

/**
 * Created by vntopmas@gmail.com
 * Email: vntopmas@gmail.com
 **/
class SubMainLayoutHelper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: true };
  }

  componentDidMount() {
    this.handleOnChangeLayout();
    this.setState({ subRoutes: getSubRoutes(this) });
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props;
    const nextLocation = nextProps.location;
    if (location.pathname === nextLocation.pathname) {
      return;
    }
    if (!this.state.subRoutes) {
      this.setState({ subRoutes: getSubRoutes(this) });
    }
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  handleOnChangeLayout = (nextProps) => {
    const { dispatch, location, route, authInfo, user } = nextProps || this.props;
    const branches = matchRoutes(route.routes, location.pathname);
    if (!branches || branches.length === 0) {
      return;
    }

    const branchRoute = branches[0].route;
    if (branchRoute && branchRoute.layout && (!this.state.layoutId || branchRoute.layout !== this.state.layoutId)) {
      const layoutId = branchRoute.layout;
      this.setState({ layoutId });
    }

    branches.map((branch) => {
      checkPermissionsOfRoute(branch.route, dispatch, history, authInfo, user);
    });
  };

  render() {
    const { subRoutes } = this.state;
    if (!isValidRoute(this.props)) {
      return <PageNotfound/>;
    }

    return (<div>
      {renderRoutes(subRoutes)}
    </div>);
  }
}

const mapStateToProps = (state) => ({
  currentLayout: state.layout,
  user: state.user.user,
  authInfo: state.user,
});

export default connect(mapStateToProps)(SubMainLayoutHelper);
